import './Refresh.scss';

import React from 'react';
import Svg from '@justgiving/svg';
import classNames from 'classnames';
import { refreshIcon } from '@justgiving/icons';
import { useTranslation } from 'react-i18next';

interface RefreshProps {
  buttonLabel?: string;
  children: React.ReactNode;
  className?: string;
  displayRefreshButton?: boolean;
  onRefresh?: () => void;
}

const Refresh: React.FunctionComponent<RefreshProps> = ({
  buttonLabel,
  children,
  className,
  displayRefreshButton = true,
  onRefresh,
}) => {
  const handleRefreshClick = () => {
    onRefresh ? onRefresh() : window.location.reload();
  };

  const { t } = useTranslation();

  return (
    <div className={classNames('refreshContainer', className)}>
      {children}
      {displayRefreshButton && (
        <button
          className="refreshButton"
          onClick={handleRefreshClick}
          aria-label={buttonLabel ?? t('common.refresh')}
        >
          <Svg markup={refreshIcon} className="refreshIcon" />
        </button>
      )}
    </div>
  );
};

export default Refresh;
